import { Link } from "react-router-dom";
import { MapPin, Clock, ArrowRight } from "lucide-react";

const badgeColors = {
  "Hot Selling": "bg-brandred text-white",
  "Fast Selling": "bg-brandorange text-white",
  "Almost Sold Out": "bg-navy text-white",
  "Available": "bg-emerald-500 text-white",
};

export default function TourCard({ tour, index = 0 }) {
  return (
    <Link
      to={`/tour/${tour.slug}`}
      data-testid={`tour-card-${tour.slug}`}
      className="group block overflow-hidden rounded-3xl bg-white card-soft hover-lift"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={tour.hero_image}
          alt={tour.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
        <div className="absolute left-3 top-3 flex flex-wrap gap-2">
          <span className="rounded-full bg-white/90 px-3 py-1 text-xs font-bold text-navy">{tour.package_type}</span>
          {(tour.badges || []).slice(0, 1).map((b) => (
            <span key={b} className={`rounded-full px-3 py-1 text-xs font-bold ${badgeColors[b] || "bg-navy text-white"}`}>{b}</span>
          ))}
        </div>
      </div>
      <div className="p-5">
        <div className="mb-2 flex items-center gap-4 text-xs font-medium text-gray-500">
          <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5 text-brandorange" /> {tour.destination}</span>
          <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5 text-brandorange" /> {tour.duration}</span>
        </div>
        <h3 className="font-display text-xl font-bold text-navy line-clamp-1">{tour.title}</h3>
        <p className="mt-1 line-clamp-2 text-sm text-gray-500">{tour.short_description}</p>
        <div className="mt-4 flex items-center justify-between">
          <div>
            <span className="text-xs text-gray-400">Starting from</span>
            <div className="font-display text-2xl font-extrabold text-navy">₹{Number(tour.price).toLocaleString("en-IN")}</div>
          </div>
          <span className="flex h-11 w-11 items-center justify-center rounded-full brand-gradient text-white transition-transform group-hover:translate-x-1">
            <ArrowRight className="h-5 w-5" />
          </span>
        </div>
      </div>
    </Link>
  );
}

export function TourCardSkeleton() {
  return (
    <div className="overflow-hidden rounded-3xl bg-white card-soft">
      <div className="aspect-[4/3] skeleton" />
      <div className="space-y-3 p-5">
        <div className="h-3 w-1/3 skeleton rounded" />
        <div className="h-5 w-3/4 skeleton rounded" />
        <div className="h-4 w-full skeleton rounded" />
        <div className="h-8 w-1/2 skeleton rounded" />
      </div>
    </div>
  );
}
